import { DialogProps, Stack, SxProps, Typography } from "@mui/material";
import { Dialog } from "components/Dialog";
import { ImportButton } from "components/ImportButton";
import { ReactNode, useState } from "react";

interface ImportDialogProps {
  importers: { name: string; importer: ReactNode }[];
  sx?: SxProps;
  onClose: () => void;
}

export function ImportDialog({
  importers,
  open,
  onClose,
}: ImportDialogProps & Pick<DialogProps, "open" | "onClose">) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      title="Choose Import Template"
      noPrimaryAction
    >
      <Stack spacing={1}>
        {importers.map((importer) => (
          <Stack direction="row" sx={{ minWidth: 400 }} key={importer.name}>
            <Typography flexGrow={1}>{importer.name}</Typography>
            {importer.importer}
          </Stack>
        ))}
      </Stack>
    </Dialog>
  );
}

export function ImportButtonWithDialog(
  props: Omit<ImportDialogProps, "onClose">
) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <ImportButton onClick={() => setIsOpen(true)} />
      <ImportDialog
        importers={props.importers}
        open={isOpen}
        onClose={() => setIsOpen(false)}
      />
    </>
  );
}
